import React, { Component } from "react"

class NetpointRectangle extends Component {
  render() {
    return <div id="netpoint_rectangle"></div>
  }
}

export default NetpointRectangle
